import tabletConstant from '../constants/tablet';
import { getTablets } from '../../api/tablet';
import store from '../store';

export const fetchTablets = () => async (dispatch) => {
  const { user } = store.getState().auth;
  if (user) {
    // const masterUser = user.isAdmin ? user.id : user.masterUser;
    const masterUser = user && (user.masterUserId || user.id);
    const data = await getTablets(masterUser);
    return dispatch({ type: tabletConstant.FETCH, tablets: data.data.tablets });
  }
};

export const updateTablet = (tablet) => ({
  type: tabletConstant.UPDATE,
  tablet,
});
